<template>
	<button class="base-rounded connection-btn mt-5">
	<v-row @click="redirectToGoogle" align="center" justify="center">
		<v-col class="d-flex justify-center" cols="2">
			<v-img
				src="/assets/google-icon.png"
				max-height="40"
				max-width="40"
			/>
		</v-col>
		<v-col class="d-flex justify-center align-center" cols="9">
			<h3 class="connection-btn--text font-weight-medium" type="submit">
				{{ $t("loginPage.googleLogin") }}
			</h3>
		</v-col>
	</v-row>
</button>
</template>

<script>
export default {
	name: "GoogleButton",
	methods: {
		redirectToGoogle () {
			// save current project here
			let redirect = "/login/google";
			if (this.$route.query.p) {
				sessionStorage.setItem("activeProject", this.$route.query.p);
				redirect += `?p=${this.$route.query.p}`;
			}
			window.location = redirect;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../sass/generic";


</style>
